module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "py-3": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.abandon()
      }
    }
  }, [_vm._v("Abandon Game")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8432f198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/routes/OptionsView.vue
// module id = 341
// module chunks = 0